module.exports = __webpack_public_path__ + "static/media/7.89635c32.gif";